<template>
  <div class="data-view -gc-card" :class="type">
    <div class="header">
      <div class="title">
        <span>{{ title }}</span>
        <el-tooltip :content='tip' v-if="tip">
          <i class="iconfont icon-xiangqing-xian"></i>
        </el-tooltip>
      </div>
      <div class="icon">
        <i class="iconfont" :class="icon"></i>
      </div>
    </div>
    <div class="content">
      <span>{{ value === '' ? '－' : (valFormat ? $numFormat(value, this.pointNum) : value)}}</span>
      <span v-if="suffix">{{ suffix }}</span>
    </div>
    <div class="contrast-view" v-if="contrast">
      <li>
        <div>
          <i class="iconfont" :class="iconClass(contrastLeftVal)"></i>
          <span>{{ Math.abs(contrastLeftVal) }}%</span>
        </div>
        <p>{{ constrastLeftText || $t('chatbot.vsday') }}</p>
      </li>
      <li>
        <div>
          <i class="iconfont" :class="iconClass(contrastRightVal)"></i>
          <span>{{ Math.abs(contrastRightVal) }}%</span>
        </div>
        <p>{{ constrastRightText || $t('chatbot.vsday7')}}</p>
      </li>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'blue' // blue、green
    },
    value: {
      type: String | Number,
      default: ''
    },
    // 小数点保留的位数（用pointNum属性计算）
    point: {
      type: Number
    },
    // 是否需要value格式化
    valFormat: {
      type: Boolean,
      default: true
    },
    suffix: {
      type: String,
      default: ''
    },
    // 是否显示底部对比
    contrast: {
      type: Boolean,
      default: false
    },
    constrastLeftText: {
      type: String,
      default: ''
    },
    constrastRightText: {
      type: String,
      default: ''
    },
    contrastLeftVal: {
      type: Number | String,
      default: ''
    },
    contrastRightVal: {
      type: Number | String,
      default: ''
    }
  },
  computed: {
    pointNum() {
      if (this.point !== undefined) return this.point
      // 百分比和分钟保留一位小数
      if (this.suffix && ['%', 'min'].includes(this.suffix)) return 1
      // 默认0位
      return 0
    }
  },
  methods: {
    iconClass(v) {
      return v >= 0 ? 'icon-shangsheng' : 'icon-xiajiang'
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  margin: 0;
}
.data-view{
  padding: 12px 20px 24px 20px;
  word-break: break-word;
  display: flex;
  flex-direction: column;
  &:has(.contrast-view){
    padding-bottom: 12px;
  }
  &.blue{
    >.header>.icon{
      background: #E8F0FD;
      color: #1763E5;
    }
  }
  &.green{
    >.header>.icon{
      background: #E4F7F6;
      color: #44C9C1;
    }
  }
  >.header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    >.title{
      font-size: 14px;
      color: #5C5E66;
      >span{
        margin-right: 4px;
      }
      .icon-xiangqing-xian{
        position: relative;
        top: 1px;
      }
    }
    >.icon{
      width: 36px;
      height: 36px;
      background: #E8F0FD;
      border-radius: 100%;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 8px;
      >.iconfont{
        font-size: 24px;
      }
    }
  }
  >.content{
    flex: 1;
    >span{
      color: #2E2F33;
      font-weight: bold;
      &:nth-child(1){
        font-size: 44px;
      }
      &:nth-child(2){
        margin-left: 4px;
        font-size: 24px;
      }
    }
  }
  >.contrast-view{
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    margin-top: 12px;
    >li{
      width: 50%;
      position: relative;
      &:first-child{
        &::after{
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          right: -0.5px;
          width: 1px;
          background: rgba(218, 224, 242, 1);
        }
      }
      &:last-child{
        padding-left: 20px;
      }
      >div{
        display: flex;
        align-items: center;
        &:has(.icon-shangsheng){
          color: #0ABB56;
        }
        &:has(.icon-xiajiang){
          color: #F94C3B;
        }
        >i{
          margin-right: 8px;
          font-size: 20px;
        }
        >span{
          font-size: 14px;
        }
      }
      >p{
        font-size: 12px;
        line-height: 18px;
        color: #8B8E9A;
      }
    }
  }
}
</style>>



// WEBPACK FOOTER //
// src/components/common/baseDataCard.vue